/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
// import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import ListItemText from '@material-ui/core/ListItemText';
import '../../Layouts/Forms/UserForms/AddForm.css';
import '../Leaves/Leave.css';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import "./job.css";
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';



const iniJob = {
    jobtitle: "",
    jobdescription: "",
    roleresponsibilities: "",
    exprequire: "",
    minqualification: "",
    jobactive: "",
    numofvacanciese: '',
    Companyprofile: "",

}

const jobPortalMenuProps = {
    PaperProps: {
        className: "holiday-year-menu"
    }
};


const AddJob = (props) => {
    const classes = props;
    const [jobportal, setJobPortal] = useState(iniJob);
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);

    const openDropdown = (field, event) => {
        setActiveDropdown(field);
        setDropdownAnchorEl(event.currentTarget);
    };

    const closeDropdown = () => {
        setActiveDropdown(null);
        setDropdownAnchorEl(null);
    };

    const updateDropdownValue = (field, value) => {
        setJobPortal({ ...jobportal, [field]: value });
        if (formErrors[field]) {
            setFormErrors({ ...formErrors, [field]: "" });
        }
        closeDropdown();
    };
    const [qualifications, setQualifications] = useState([]);
    const [Experience, setExperience] = useState([]);

    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
        getQualificationData();
        EexpData();
    }, []);

    const getQualificationData = async () => {
        try {
            // Replace the following line with your actual API call
            const response = await AuthApi.getQulification();
            if (response && response.data) {
                setQualifications(response.data);
            }
        } catch (error) {
            console.error('Error fetching qualification data:', error);
        }
    };


    const EexpData = async (e) => {
        const exp = await AuthApi.getExperience();
        try {
            if (exp && exp.data) {
                setExperience(exp.data);
            }
        } catch (error) {
            console.error('Error fetching qualification data:', error);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setJobPortal({ ...jobportal, [name]: value });
        if (formErrors[name]) {
            setFormErrors({ ...formErrors, [name]: "" });
        }
    };

    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const ds = /^[0-9\b]+$/;
        // const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

        if (!values.jobtitle) {
            errors.jobtitle = "Cannot be blank";
        }


        if (!values.jobdescription) {
            errors.jobdescription = "Cannot be blank";
        } else if (!regex.test(values.jobdescription)) {
            errors.jobdescription = "Invalid jobdescription format";
        }

        if (!values.roleresponsibilities) {
            errors.roleresponsibilities = "Cannot be blank";
        } else if (!regex.test(values.roleresponsibilities)) {
            errors.roleresponsibilities = "Invalid roleresponsibilities format";
        }


        if (values.exprequire !== "" && values.exprequire !== null && values.exprequire !== undefined && !ds.test(values.exprequire)) {
            errors.exprequire = "Invalid experience format";
        }

        if (values.numofvacanciese === "" || values.numofvacanciese === null || values.numofvacanciese === undefined) {
            errors.numofvacanciese = "Cannot be blank";
        } else if (!ds.test(String(values.numofvacanciese))) {
            errors.numofvacanciese = "Only numeric values allowed";
        }

        if (!values.Companyprofile) {
            errors.Companyprofile = "Cannot be blank";
        } else if (!regex.test(values.Companyprofile)) {
            errors.Companyprofile = "Invalid Companyprofile format";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(jobportal);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await job();
    };

    const job = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            let create = await AuthApi.createjob(jobportal);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Job added successfully", "success").then(() => {
                    props.history.push('/job');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "fail",
                    message: "Something went wrong, Please try later!"
                })
            }
        } catch (error) {
            swal.close();
            console.error("Error updating job:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    const renderDropdown = (field, label, options) => {
        const selectedValue = jobportal[field] || "";
        const hasError = Boolean(formErrors[field]);

        return (
            <React.Fragment>
                <TextField
                    fullWidth
                    variant="outlined"
                    label={label}
                    value={
                        selectedValue === "" 
                            ? "None" 
                            : (field === "exprequire" && selectedValue !== "" ? `${options.find(o => o.value === selectedValue)?.label || selectedValue}` : selectedValue)
                    }
                    onClick={(event) => openDropdown(field, event)}
                    error={hasError}
                    inputProps={{ readOnly: true }}
                    className={hasError ? "user-searchable-select-trigger-error" : ""}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <ExpandMoreIcon />
                            </InputAdornment>
                        ),
                        style: { cursor: "pointer" },
                        className: "user-searchable-select-trigger"
                    }}
                />
                <Popover
                    open={activeDropdown === field}
                    anchorEl={dropdownAnchorEl}
                    onClose={closeDropdown}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    PaperProps={{
                        className: "user-searchable-popover-paper",
                    }}
                >
                    <Box p={1.5} className="user-searchable-popover-header">
                        <Typography variant="subtitle2" className="user-searchable-popover-title">
                            {label}
                        </Typography>
                    </Box>
                    <Divider />
                    <div className="user-searchable-popover-list">
                        <MenuItem
                            className="attendance-user-option"
                            onClick={() => updateDropdownValue(field, "")}
                        >
                            <ListItemText primary="None" />
                            {!selectedValue && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
                        </MenuItem>
                        {options.map((option) => {
                            const isSelected = String(selectedValue) === String(option.value);
                            return (
                                <MenuItem
                                    key={`${field}-${option.value}`}
                                    className="attendance-user-option"
                                    onClick={() => updateDropdownValue(field, option.value)}
                                >
                                    <Box display="flex" alignItems="center" width="100%">
                                        <ListItemText primary={option.label} />
                                        {isSelected && <CheckIcon style={{ color: "#16a34a", fontSize: "1.2rem" }} />}
                                    </Box>
                                </MenuItem>
                            );
                        })}
                        {options.length === 0 && (
                            <div className="user-searchable-empty-state">No results found</div>
                        )}
                    </div>
                </Popover>
                {hasError && <span className="error">{formErrors[field]}</span>}
            </React.Fragment>
        );
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                            <Breadcrumb
                                {...props}
                                primaryPageName="Job-Portal"
                                primaryPageLink="/job"
                                isSecondaryPage={true}
                                secondaryPageName="Add Job-Portal" />
                        </div>
                        <div className="holiday-form-card">
                            <Typography variant="h2" className="common-form-page-title holiday-form-title">
                                Add Job-Portal
                            </Typography>
                            <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="Job Title"
                                                        name="jobtitle"
                                                        label="Job-Title"
                                                        variant="outlined"
                                                        error={formErrors.jobtitle && true}
                                                        value={jobportal.jobtitle}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.jobtitle ? "input-error" : ""}`}

                                                    />
                                                    {formErrors.jobtitle && (
                                                        <span className="error">{formErrors.jobtitle}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="Number of vacanciese"
                                                        name="numofvacanciese"
                                                        label="Number of vacancies"
                                                        variant="outlined"
                                                        error={formErrors.numofvacanciese && true}
                                                        value={jobportal.numofvacanciese}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.numofvacanciese ? "input-error" : ""}`}

                                                    />
                                                    {formErrors.numofvacanciese && (
                                                        <span className="error">{formErrors.numofvacanciese}</span>
                                                    )}
                                                </Grid>


                                            </Grid>

                                            <Grid container className={classes.root} spacing={5} style={{ marginTop: "8px" }} >
                                                <Grid item xs={4}>
                                                    {renderDropdown("exprequire", "Exp. required", Experience.map(item => ({ value: item.maxExpYear, label: `${item.minExpYear} to ${item.maxExpYear}` })))}
                                                </Grid>

                                                <Grid item xs={4}>
                                                    {renderDropdown("minqualification", "Min. Qualification", qualifications.map(q => ({ value: q.qualification, label: q.qualification })))}
                                                </Grid>

                                                <Grid item xs={4}>
                                                    {renderDropdown("jobactive", "Job active", [
                                                        { value: "yes", label: "Yes" },
                                                        { value: "no", label: "No" }
                                                    ])}
                                                </Grid>
                                            </Grid>

                                            {/* <Grid container className={classes.root} spacing={5}>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={4}></Grid>
                                                    <Grid item xs={4}></Grid>
                                                </Grid> */}

                                            <Grid container className={classes.root} spacing={5} style={{ marginTop: "8px" }} >
                                                <Grid item xs={4} >
                                                    {/* <TextareaAutosize
                                                        // fullWidth
                                                        // multiline
                                                        rows={2}
                                                        id="Job Description"
                                                        variant="outlined"
                                                        label="Job Description"
                                                        name="jobdescription"
                                                        placeholder="Job Description"
                                                        style={{ width: '528px', height: "60px", marginRight: "-24px" }}
                                                        error={formErrors.jobdescription}
                                                        value={jobportal.jobdescription}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.jobdescription ? "input-error" : ""}`}
                                                        className={classes.textField}
                                                    // InputLabelProps={{
                                                    //     shrink: true,
                                                    // }}
                                                    /> */}
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        label="Job Description"
                                                        name="jobdescription"
                                                        error={formErrors.jobdescription}
                                                        value={jobportal.jobdescription}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.jobdescription ? "input-error" : ""}`}
                                                    />
                                                    {formErrors.jobdescription && (
                                                        <span className="error">{formErrors.jobdescription}</span>
                                                    )}

                                                </Grid>

                                                <Grid item xs={4}>
                                                    {/* <TextareaAutosize
                                                        // fullWidth
                                                        // multiline
                                                        rows={2}
                                                        id="Company profile"
                                                        variant="outlined"
                                                        label="Company Profile"
                                                        name="Companyprofile"
                                                        placeholder="Company Profile"
                                                        style={{ width: '528px', height: "60px" }}
                                                        error={formErrors.Companyprofile}
                                                        value={jobportal.Companyprofile}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.Companyprofile ? "input-error" : ""}`}
                                                        className={classes.textField}
                                                    // InputLabelProps={{
                                                    //     shrink: true,
                                                    // }}
                                                    /> */}
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        label="Company Profile"
                                                        name="Companyprofile"
                                                        error={formErrors.Companyprofile}
                                                        value={jobportal.Companyprofile}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.Companyprofile ? "input-error" : ""}`}
                                                    />
                                                    {formErrors.Companyprofile && (
                                                        <span className="error">{formErrors.Companyprofile}</span>
                                                    )}

                                                </Grid>

                                                <Grid item xs={4}>
                                                    {/* <TextareaAutosize
                                                        // fullWidth
                                                        // multiline
                                                        rows={2}
                                                        id="Role&responsibilities"
                                                        variant="outlined"
                                                        label="Role & Responsibility"
                                                        name="roleresponsibilities"
                                                        placeholder="Role & Responsibility"
                                                        style={{ width: '528px', height: "60px", marginRight: "21px" }}
                                                        error={formErrors.roleresponsibilities}
                                                        value={jobportal.roleresponsibilities}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.roleresponsibilities ? "input-error" : ""}`}
                                                        className={classes.textField}
                                                    // InputLabelProps={{
                                                    //     shrink: true,
                                                    // }}
                                                    /> */}
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        label="Role & Responsibility"
                                                        name="roleresponsibilities"
                                                        error={formErrors.roleresponsibilities}
                                                        value={jobportal.roleresponsibilities}
                                                        onChange={handleChange}
                                                        className={`holiday-form-input ${formErrors.roleresponsibilities ? "input-error" : ""}`}
                                                    />
                                                    {formErrors.roleresponsibilities && (
                                                        <span className="error">{formErrors.roleresponsibilities}</span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <div className="holiday-form-actions" style={{ marginTop: "49px", display: "flex", justifyContent: "flex-start", gap: "10px" }}>
                                                <Button type="submit" variant="contained" className="btn-success" disabled={submitLoading} style={{ textTransform: 'none' }}>
                                                    {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                </Button>
                                                <Button type="button" className="btn-cancel" disabled={submitLoading} onClick={(e) => { e.preventDefault(); props.history.push('/job') }} style={{ textTransform: 'none' }}>
                                                    Cancel
                                                </Button>
                                            </div>
                            </form>
                        </div>
                    </div>
                } />
            <Footer />
        </div>
    )
}

export default AddJob;
